// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q4nR","badges":"styles_badges__dw-XA"};